import React from 'react'

import { cn } from '@/lib/utils'
import { formatCurrency } from '@/lib/format'

interface CurrencyAmountProps {
  amount: number
  className?: string
  iconClassName?: string
  textClassName?: string
}

/**
 * Displays a currency amount with the Saudi Riyal SVG symbol.
 * Uses formatCurrency with showSymbol: false to avoid duplicating symbols.
 */
export const CurrencyAmount: React.FC<CurrencyAmountProps> = ({
  amount,
  className,
  iconClassName,
  textClassName,
}) => {
  return (
    <div className={cn('inline-flex items-baseline gap-2', className)}>
      <img
        src="/images/logos/sr.svg"
        alt="Saudi Riyal"
        className={cn('h-5 w-5 object-contain', iconClassName)}
      />
      <span className={cn('', textClassName)}>
        {formatCurrency(amount, { currency: 'SAR', showSymbol: false })}
      </span>
    </div>
  )
}

export default CurrencyAmount


